module.exports = __webpack_public_path__ + "static/img/4014.23d469a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4014.png
// module id = 721
// module chunks = 0 1 12